import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { PackVerification_ShellService } from './PackVerification.shell.service';
import { PackVerification_OperationService } from './PackVerification.operation.service';
import { PackVerification_DatasourceService } from './PackVerification.datasource.index';
import { PackVerification_FlowService } from './PackVerification.flow.index';
import { PackVerification_ReportService } from './PackVerification.report.index';
import { PackVerification_LocalizationService } from './PackVerification.localization.service';
import { PackVerification_pack_verification_home_ComponentContextService } from './PackVerification.pack_verification_home.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './PackVerification.frontend.types'
import { $frontendTypes as $types} from './PackVerification.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { PackVerification_packing_list_previewComponent } from './PackVerification.packing_list_preview.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => PackVerification_packing_list_previewComponent),
  ],
  selector: 'PackVerification-pack_verification_home',
  templateUrl: './PackVerification.pack_verification_home.component.html'
})
export class PackVerification_pack_verification_homeComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    shipping_container_id: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    test: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
    shipping_container_id: new FieldModel(new NumberBoxModel(this.formGroup.controls['shipping_container_id'] as DatexFormControl, null, false, false, '', '', null)
, new ControlContainerStyles(null, null), 'Shipping container ID', false, false),
    test: new FieldModel(new TextBoxModel(this.formGroup.controls['test'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Test', false, false),
  };


  filtersets = {
    fields: new FieldsetModel(
      'Fields',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    widgets = {
      preview_packing_list: new WidgetModel(false),
    };
  
    //#region widgets inParams
    get $widgets_preview_packing_list_inParams_shippingContainerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = 21542;
      
      return expr;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_preview_packing_list', { read:  PackVerification_packing_list_previewComponent }) $widgets_preview_packing_list: PackVerification_packing_list_previewComponent;
    //#endregion widgets children

  //#region filters inParams
  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `pack_verification_home`;
  }


  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: PackVerification_ShellService,
  private $datasources: PackVerification_DatasourceService,
  private $flows: PackVerification_FlowService,
  private $reports: PackVerification_ReportService,
  private $localization: PackVerification_LocalizationService,
  private $operations: PackVerification_OperationService,
  private $logger: CleanupLoggerService,
  private $context: PackVerification_pack_verification_home_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Pack verification';
    
    const $hub = this;
    const $utils = this.$utils;

    

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_preview_packing_list') {
      if (!isNil(this.$widgets_preview_packing_list) && !this.widgets.preview_packing_list.hidden) {
        this.$widgets_preview_packing_list.refresh(true, false, null);
      }
    }
    //#endregion widgets children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: PackVerification_pack_verification_homeComponent,
  
    $shell: PackVerification_ShellService,
    $datasources: PackVerification_DatasourceService,
    $flows: PackVerification_FlowService,
    $reports: PackVerification_ReportService,
    $settings: SettingsValuesService,
    $operations: PackVerification_OperationService,
    $utils: UtilsService,
    $context: PackVerification_pack_verification_home_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: PackVerification_LocalizationService,
    $event: any
  ) {
    this.$logger.log('PackVerification', 'pack_verification_home.on_init');
  
  }
  on_value_changed(event = null) {
    return this.on_value_changedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_value_changedInternal(
    $hub: PackVerification_pack_verification_homeComponent,
  
    $shell: PackVerification_ShellService,
    $datasources: PackVerification_DatasourceService,
    $flows: PackVerification_FlowService,
    $reports: PackVerification_ReportService,
    $settings: SettingsValuesService,
    $operations: PackVerification_OperationService,
    $utils: UtilsService,
    $context: PackVerification_pack_verification_home_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: PackVerification_LocalizationService,
    $event: any
  ) {
    this.$logger.log('PackVerification', 'pack_verification_home.on_value_changed');
  
  let elements = document.getElementsByTagName('packverification-label_preview');
  
  if (elements) {
      let div = elements[0].parentNode as HTMLElement;
  
      // @ts-ignore
      div.style.hidden = true;
  }
  }
  //#endregion private flows
}
